module.exports = __webpack_public_path__ + "img/banner-web-3.73ec0962.png";